// @flow

import React, { Component }      from 'react';
import { connect }               from 'react-redux';
import { getTranslate }          from 'react-localize-redux';

class ProcessingApp extends Component {

  componentDidMount() {
    let icoItems = document.querySelectorAll('.application-status .icons li');
    setInterval(() => {
      let currentIco = [].find.call(icoItems, item => item.classList.contains('active'));
      if (!currentIco) { return false; };

      currentIco.classList.remove('active');
      if (!!currentIco.nextSibling) {
        currentIco = currentIco.nextSibling.classList.add('active');
      } else {
        currentIco = icoItems[0].classList.add('active');
      }
    }, 3500);

    let items = document.querySelectorAll('.txt-slider .slide');
    setInterval(() => {
      let currentItem = [].find.call(items, item => item.classList.contains('active'));
      if (!currentItem) { return false; }

      currentItem.classList.remove('active');
      if (!!currentItem.nextSibling) {
        currentItem = currentItem.nextSibling.classList.add('active');
      } else {
        currentItem = items[0].classList.add('active');
      }

      return false;
    }, 5000);
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="search-container">
        <header className="headline">
          <h3>{translate('applications.search_matches')}</h3>
          <p>{translate('applications.brainstorm')}</p>
        </header>
        <div className="application-status">
          <ul className="icons">
            <li className="active"><i className="ico ico-4"></i></li>
            <li><i className="ico ico-2"></i></li>
            <li><i className="ico ico-3"></i></li>
            <li><i className="ico ico-5"></i></li>
            <li><i className="ico ico-6"></i></li>
            <li><i className="ico ico-7"></i></li>
          </ul>
          <div className="circle"></div>
          <img src="images/img-01.png" alt="circle" />
        </div>
        <div className="notification">
          <div className="txt-slider">
            <em className="slide active"><img src="images/ico-bulb-01.svg" alt="bulb-1" className="ico" />{translate('applications.unknown')}</em>
            <em className="slide"><img src="images/ico-bulb-01.svg" alt="bulb-2" className="ico" />{translate('applications.three_days')}</em>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
});

export default connect(mapStateToProps)(ProcessingApp);



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/processingApp.js